export default {"src":"https://fishbrain.com/_next/static/media/pennsylvania.940d2b5c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};